module.exports = __webpack_public_path__ + "download/img/uniondrug.e7e5fc21.png";